var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.75 30C53.75 33.1189 53.1357 36.2072 51.9421 39.0887C50.7486 41.9702 48.9992 44.5884 46.7938 46.7938C44.5884 48.9992 41.9702 50.7486 39.0887 51.9421C36.2072 53.1357 33.1189 53.75 30 53.75C26.8811 53.75 23.7928 53.1357 20.9113 51.9421C18.0298 50.7486 15.4116 48.9992 13.2062 46.7938C11.0008 44.5884 9.25141 41.9702 8.05786 39.0887C6.86431 36.2072 6.25 33.1189 6.25 30",
    stroke: "url(#paint0_linear_1908_23843)",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C15 28.0302 15.388 26.0796 16.1418 24.2597C16.8956 22.4399 18.0005 20.7863 19.3934 19.3934C20.7863 18.0005 22.4399 16.8956 24.2597 16.1418C26.0796 15.388 28.0302 15 30 15C31.9698 15 33.9204 15.388 35.7403 16.1418C37.5601 16.8956 39.2137 18.0005 40.6066 19.3934C41.9995 20.7863 43.1044 22.4399 43.8582 24.2597C44.612 26.0796 45 28.0302 45 30",
    stroke: "url(#paint1_linear_1908_23843)",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30C25 30.6566 25.1293 31.3068 25.3806 31.9134C25.6319 32.52 26.0002 33.0712 26.4645 33.5355C26.9288 33.9998 27.48 34.3681 28.0866 34.6194C28.6932 34.8707 29.3434 35 30 35C30.6566 35 31.3068 34.8707 31.9134 34.6194C32.52 34.3681 33.0712 33.9998 33.5355 33.5355C33.9998 33.0712 34.3681 32.52 34.6194 31.9134C34.8707 31.3068 35 30.6566 35 30",
    stroke: "url(#paint2_linear_1908_23843)",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1908_23843",
    x1: 13.1125,
    y1: 13.375,
    x2: 54.1875,
    y2: 41.2132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FB8C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7977F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1908_23843",
    x1: 18.7417,
    y1: 18.9167,
    x2: 46.125,
    y2: 37.4755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FB8C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7977F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1908_23843",
    x1: 25.175,
    y1: 34.75,
    x2: 36.9107,
    y2: 26.7962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FB8C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7977F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinImg);
export default __webpack_public_path__ + "static/media/spin-img.f828ef0466b8294b1185492563f1f66b.svg";
export { ForwardRef as ReactComponent };